export default __webpack_public_path__ + "static/media/643.be51ea78.gif";